var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortSleeveTshirt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2369_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2092 10.459H18.0381C17.3504 10.459 16.793 11.0151 16.793 11.7028C16.793 12.3904 17.3504 12.9465 18.0381 12.9465H22.2092C22.8969 12.9465 23.4543 12.3904 23.4543 11.7028C23.4543 11.0151 22.8969 10.459 22.2092 10.459Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5053 0H2.64626C1.21309 0 0 1.15245 0 2.57728V10.6007C0 12.0292 1.21309 13.2103 2.64626 13.2103H4.80546V28.5063C4.80546 29.8793 5.95387 31 7.32207 31H25.785C27.1434 31 28.2109 29.8793 28.2109 28.5063V13.2103H30.5054C31.9385 13.2103 33.0729 12.0292 33.0729 10.6007V2.57728C33.0729 1.15245 31.9385 0 30.5053 0ZM20.5265 2.48754C20.0259 4.24012 18.4404 5.45939 16.5659 5.45939C14.6914 5.45939 13.1059 4.24012 12.6053 2.48754H20.5265ZM30.5665 10.6007C30.5665 10.6495 30.5583 10.704 30.5053 10.704H27.0035C26.3159 10.704 25.7233 11.2586 25.7233 11.9462V28.5125H7.29299V11.9462C7.29299 11.2586 6.77355 10.704 6.08586 10.704H2.64626C2.59333 10.704 2.50638 10.6495 2.50638 10.6007V2.57728C2.50638 2.53508 2.58762 2.48754 2.64626 2.48754H10.0505C10.5982 5.61581 13.3113 7.94961 16.5659 7.94961C19.8205 7.94961 22.5336 5.61581 23.0813 2.48754H30.5053C30.564 2.48754 30.5665 2.53506 30.5665 2.57728V10.6007V10.6007Z",
    fill: "#A6A6A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2369_467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.0729,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortSleeveTshirt);
export default __webpack_public_path__ + "static/media/short_sleeve_tshirt.bbd7bf65a4e33d014b46e819ee296481.svg";
export { ForwardRef as ReactComponent };